/* eslint-disable semi */
import { env } from '../../../env';
/* -------------------------------------------------------------------------- */
/*                                 HUBBASEURL                                 */
/* -------------------------------------------------------------------------- */
//Localhost Development
const HUB_BASE_URL = env.VITE_HUB_BASE_URL;
export default HUB_BASE_URL;
